<template>
  <zt-modal
    :active="activeModal"
    :title="$t('message.DownloadAllDocuments.downloadModal.title')"
    @close="closeModal"
    max-width="600px"
  >
    <div class="flex flex-col items-center justify-center py-24">
      <template v-if="isLinkActive">
        <div>
          <DownloadOkSVG />
        </div>
        <div class="pt-4 text-center text-zt-lg">
          <p>
            {{
              $t(
                'message.DownloadAllDocuments.downloadModal.messageInitialDownload'
              )
            }}
          </p>
          <p>
            {{
              $t(
                'message.DownloadAllDocuments.downloadModal.problemWithDownloadLink'
              )
            }}
            <button
              data-vs-button="download-zip"
              class="font-bold underline"
              @click="downloadZip"
            >
              {{ $t('message.DownloadAllDocuments.downloadModal.clickHere') }}
            </button>
          </p>
        </div>
      </template>
      <template v-else>
        <div>
          <DownloadExpiredSVG />
        </div>
        <div class="pt-4 text-center text-zt-lg">
          <p>
            {{
              $t('message.DownloadAllDocuments.downloadModal.expiredDownload')
            }}
          </p>
          <p v-if="!isIframe">
            {{ $t('message.DownloadAllDocuments.downloadModal.retryDownload') }}
            <button
              data-vs-button="send-documents"
              class="font-bold underline"
              @click="sendToDocuments"
            >
              {{ $t('message.DownloadAllDocuments.downloadModal.clickHere') }}
            </button>
          </p>
          <p v-else>
            {{ $t('message.DownloadAllDocuments.downloadModal.iframeRetryDownload') }}
          </p>
        </div>
      </template>
    </div>
    <template #modal-footer>
      <div class="flex justify-end p-4 bg-zt-dark-100">
        <zt-button data-vs-button="close-modal" @click="closeModal">{{
          $t('message.DownloadAllDocuments.understood')
        }}</zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
import DownloadExpiredSVG from '../SVG/DownloadExpiredSVG'
import DownloadOkSVG from '../SVG/DownloadOkSVG'
import Users from '@/apiClient/Users'

const binArrayToString = binArray => {
  let str = ''
  for (let i = 0; i < binArray.length; i++) {
    str += String.fromCharCode(parseInt(binArray[i], 10))
  }
  return str
}

const handleData = async data => {
  const element = document.createElement('a')

  /*TODO Safari Solution
  const blob = new Blob([data], { type: 'application/octet-stream' })
  const blobUrl = URL.createObjectURL(blob)*/
  element.href = `${data}`
  element.click()
}

export default {
  name: 'DownloadModal',
  components: {
    DownloadExpiredSVG,
    DownloadOkSVG
  },
  props: ['activeModal', 'expiredStatus', 'closeModal', 'fileLink', 'isIframe'],
  data() {
    return {
      userInstance: new Users()
    }
  },
  created() {
    if (this.isIframe === undefined) {
      this.$set(this, 'isIframe', false)
    }
  },
  computed: {
    isLinkActive() {
      return !this.expiredStatus
    },
    iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    },
    performanceSourceUrlData() {
      return this.$iframeMessages.performanceSourceUrlData()
    }
  },
  methods: {
    sendToDocuments() {
      this.$router.push({ name: 'documents', params: { expired: true } })
      this.$store.dispatch('auth/setParamLoginFactory', '')
    },
    downloadZip() {
      if (this.isIframe && this.iframeTokenValid) {
        window.open(this.fileLink, '_blank');
      } else {
          handleData(this.fileLink)
      }
    }
  },
  watch: {
    fileLink(newValue) {
      if (newValue) {
        this.downloadZip()
      }
    }
  }
}
</script>
